export default {
  metadata: {
    version: '1.0.0',
    id: 'file-uploader-item-1.0.0',
    name: 'JDSFileUploaderItem'
  },
  hierarchy: {
    container: [
      {
        'file-container': [
          {
            'state-container': [
              'jds_spinner',
              {
                'state-jds-icon-container': ['state-jds-icon']
              },
              'message-jds-text'
            ]
          },
          {
            'button-container': ['suffix-jds_button']
          }
        ]
      },
      'jds_divider'
    ]
  },
  base: {
    container: {
      'flex-direction': '{f_0}',
      'justify-content': '{f_1}',
      'align-items': '{f_2}',
      width: '{f_3}',
      opacity: '{f_4}',
      'background-color': '{f_5}'
    },
    'file-container': {
      'flex-direction': '{f_6}',
      'justify-content': '{f_7}',
      'align-items': '{f_8}',
      gap: '{f_9}',
      'padding-left': '{f_10}',
      width: '{f_11}'
    },
    'state-container': {
      'flex-direction': '{f_12}',
      'justify-content': '{f_13}',
      'align-items': '{f_14}',
      gap: '{f_15}'
    },
    jds_spinner: {
      hidden: true,
      kind: 'normal',
      size: 'small'
    },
    'button-container': {
      show: true,
      size: '48',
      'align-items': '{f_16}'
    },
    'suffix-jds_button': {
      icon: 'ic_close',
      kind: 'tertiary',
      size: 'small'
    },
    jds_divider: {
      hidden: false,
      orientation: 'horizontal',
      pad: 'none'
    },
    'state-jds-icon': {
      size: '{icon_5}',
      color: '{icon_7}',
      hidden: true
    },
    'state-jds-icon-container': {
      'background-color': '{icon_0}',
      'border-radius': '{icon_1}',
      size: '{icon_2}',
      'justify-content': '{icon_3}',
      'align-items': '{icon_4}',
      hidden: true
    },
    'message-jds-text': {
      'font-family': '{text_147}',
      color: '{text_21}',
      'font-size': '{text_146}',
      'line-height': '{text_148}',
      'letter-spacing': '{text_149}',
      'font-weight': '{text_150}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      textType: 'label'
    }
  },
  variant: {
    kind: {
      collapsed: {
        'suffix-jds_button': {
          icon: 'ic_chevron_down'
        },
        jds_divider: {
          hidden: true
        }
      },
      expanded: {
        'suffix-jds_button': {
          icon: 'ic_chevron_up'
        },
        jds_divider: {
          hidden: true
        }
      }
    },
    showDivider: {
      false: {
        jds_divider: {
          hidden: true
        }
      }
    }
  },
  combination: [
    {
      normal: {
        loading: {
          jds_spinner: {
            hidden: false
          },
          'state-jds-icon': {},
          'state-jds-icon-container': {}
        },
        success: {
          jds_spinner: {
            hidden: true
          },
          'state-jds-icon': {
            color: '{icon_17}',
            value: 'ic_success_colored',
            hidden: false,
            ic: 'ic_success_colored'
          },
          'state-jds-icon-container': {
            hidden: false,
            ic: 'ic_success_colored'
          },
          'message-jds-text': {
            color: '{text_60}'
          }
        },
        error: {
          jds_spinner: {
            hidden: true
          },
          'suffix-jds_button': {
            hidden: true
          },
          'state-jds-icon': {
            color: '{icon_18}',
            value: 'ic_error_colored',
            hidden: false,
            ic: 'ic_error_colored'
          },
          'state-jds-icon-container': {
            hidden: false,
            ic: 'ic_error_colored'
          },
          'message-jds-text': {
            color: '{text_54}'
          }
        }
      }
    }
  ],
  combination_config: [['kind', 'state']],
  api: {
    config: {
      state: {
        values: ['loading', 'success', 'error']
      },
      kind: {
        values: ['normal', 'collapsed', 'expanded']
      },
      showDivider: {
        values: [true, false]
      }
    },
    data: {
      'message-jds-text': {
        value: {
          type: 'string',
          name: 'message'
        }
      }
    },
    events: {
      'suffix-jds_button': {
        onClick: 'onClick'
      }
    },
    a11y: {
      container: {
        properties: {
          role: {
            value: 'listitem'
          },
          'aria-label': {
            name: 'ariaLabel',
            prop: 'message'
          },
          'aria-describedby': {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      'suffix-jds_button': {
        properties: {
          ariaLabel: {
            name: 'suffixAriaLabel',
            value: 'Remove File'
          },
          ariaExpanded: 'ariaExpanded'
        }
      }
    }
  }
};
